import * as fromActions from '../actions/sport-active.actions';
import { StoreAction, SportState } from 'src/app/core/models/rootState.model';

const INITIAL_STATE: SportState = {
    sport: null,
    loaded: false,
    loading: false
}


export function SportActiveReducer(state = INITIAL_STATE, action: StoreAction): SportState {

    switch (action.type) {

        case fromActions.CURRENT_SPORT_ACTIONS.INIT: {
            return {
                ...state,
                loading: true
            }
        }

        case fromActions.CURRENT_SPORT_ACTIONS.INIT_SUCCESS: {
            return {
                ...state,
                loading: true
            }
        }

        case fromActions.CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT:
        case fromActions.CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT_ID_SUCCESS: {

            return {
                ...state,
                sport: action.payload,
                loading: false,
                loaded: true
            }
        }

        case fromActions.CURRENT_SPORT_ACTIONS.INIT_SUCCESS_EMPTY: {
            return {
                ...state,
                loading: false,
                loaded: true
            }
        }

        case fromActions.CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT_ID: {
            return {
                ...state,
                loading: true
            }
        }

        case fromActions.CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT_ID_FAIL: {
            return {
                ...state,
                loading: false
            }
        }

        case fromActions.CURRENT_SPORT_ACTIONS.RESSET: {
            return {
                ...INITIAL_STATE
            }
        }

        default: { return state}
    }

}